import {
  AdditiveBlending,
  Color,
  Group,
  Mesh,
  MeshBasicMaterial,
  PointLight,
  SphereGeometry,
} from 'three';
import { kicadToWorld } from '../model/CoordinateMapper';
import type { BoardComponent, RegionId } from '../types';

export interface LEDVisual {
  region: RegionId;
  root: Group;
  core: Mesh;
  halo: Mesh;
  light: PointLight;
}

export function createLEDOverlay(component: BoardComponent, region: RegionId): LEDVisual {
  const root = new Group();
  root.name = `glow-${component.ref}`;
  root.position.copy(kicadToWorld(component.x + 1.27, component.y, 0.016));

  const core = new Mesh(
    new SphereGeometry(0.0027, 18, 12),
    new MeshBasicMaterial({ color: 0x2a0808, transparent: true, opacity: 0.16 }),
  );
  core.scale.y = 1.25;
  root.add(core);

  const halo = new Mesh(
    new SphereGeometry(0.006, 16, 10),
    new MeshBasicMaterial({
      color: 0xff2b18,
      transparent: true,
      opacity: 0,
      depthWrite: false,
      blending: AdditiveBlending,
    }),
  );
  root.add(halo);

  const light = new PointLight(new Color(0xff321f), 0, 0.045, 2);
  light.position.y = 0.004;
  root.add(light);
  return { region, root, core, halo, light };
}

export function setLEDState(led: LEDVisual, on: boolean): void {
  const core = led.core.material as MeshBasicMaterial;
  const halo = led.halo.material as MeshBasicMaterial;
  core.color.setHex(on ? 0xff361f : 0x2a0808);
  core.opacity = on ? 0.98 : 0.16;
  halo.opacity = on ? 0.3 : 0;
  led.light.intensity = on ? 0.8 : 0;
}
